import {getLoggedInUser} from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';

const GetLoggedInUser = async(accessToken) => {
    try{
        const response = await getLoggedInUser(accessToken);
        return {success:true, userInfo:response.data}
    } catch(error){
        return {
          success: false,
          data: extractApiErrorMessage(error),
          error: extractApiErrorMessage(error),
          status: error.response?.status
        };
    }
}

export default GetLoggedInUser;
